/**
 * Contains a price and limit alerts renderer
 */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ILimitOrder, IPriceAlert } from '@kattana-io/common';
import AlertCard from './AlertCard';
import { actionConsumePriceAlert } from '../../../actions/price_alerts';
import { actionConsumeLimitOrder } from '../../../actions/limit_orders';
import { IStore } from '../../../reducers';

import './styles.scss';

const AlertsView = () => {
  const priceAlerts = useSelector(
    (store: IStore) => store.price_alerts.activated
  );
  const limitAlerts = useSelector(
    (store: IStore) => store.limitOrders.activated
  );

  const dispatch = useDispatch();

  const handleConsumePriceAlert = useCallback(
    (priceAlert: IPriceAlert) => {
      dispatch(actionConsumePriceAlert(priceAlert));
    },
    [dispatch]
  );

  const handleConsumeLimitAlert = useCallback(
    (limitAlert: ILimitOrder) => {
      dispatch(actionConsumeLimitOrder(limitAlert));
    },
    [dispatch]
  );

  return (
    <div className='alerts_view'>
      {priceAlerts.map((item) => (
        <AlertCard
          key={item.id}
          alert={item}
          label='Price alert!'
          consumeAlert={() => handleConsumePriceAlert(item)}
        />
      ))}
      {limitAlerts.map((item) => (
        <AlertCard
          key={item.id}
          alert={item}
          label='Limit order executed!'
          consumeAlert={() => handleConsumeLimitAlert(item)}
        />
      ))}
    </div>
  );
};

export default AlertsView;
